import { lazy, Suspense, useEffect } from 'react';
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { CartProvider } from './context/CartContext';
import SEO from './components/SEO';
import ScrollToTop from './components/ScrollToTop';
import MarketingSite from './pages/MarketingSite';

const Login = lazy(() => import('./pages/Login'));
const AuthVerify = lazy(() => import('./pages/AuthVerify'));
const SetPassword = lazy(() => import('./pages/SetPassword'));
const InvitationLanding = lazy(() => import('./pages/InvitationLanding'));
const Dashboard = lazy(() => import('./pages/Dashboard'));
const Admin = lazy(() => import('./pages/Admin'));
const Privacy = lazy(() => import('./pages/Privacy'));
const Terms = lazy(() => import('./pages/Terms'));
const Returns = lazy(() => import('./pages/Returns'));
const Shipping = lazy(() => import('./pages/Shipping'));
const AvisoLegal = lazy(() => import('./pages/AvisoLegal'));
const Withdrawal = lazy(() => import('./pages/Withdrawal'));
const VariantPage = lazy(() => import('./pages/VariantPage'));
const LayeringGuide = lazy(() => import('./pages/LayeringGuide'));
const IngredientsPage = lazy(() => import('./pages/Ingredients'));
const About = lazy(() => import('./pages/About'));
const Ecosystem = lazy(() => import('./pages/Ecosystem'));
const BlogIndex = lazy(() => import('./pages/BlogIndex'));
const BlogPost = lazy(() => import('./pages/BlogPost'));

export default function App() {
  const location = useLocation();

  // On non-landing routes, remove HTML preloader so /blog, /login etc. don't get stuck. On "/", leave it for Preloader to remove so the landing sequence stays correct.
  useEffect(() => {
    if (location.pathname !== '/') {
      const ip = document.getElementById('instant-preloader');
      if (ip) ip.remove();
    }
  }, [location.pathname]);

  return (
    <AuthProvider>
      <CartProvider>
      <ScrollToTop />
      <SEO />
      <Suspense fallback={<div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100vh', color: '#999' }}>Loading...</div>}>
        <main>
        <Routes>
          <Route path="/" element={<MarketingSite />} />
          <Route path="/login" element={<Login />} />
          <Route path="/auth/verify" element={<AuthVerify />} />
          <Route path="/auth/set-password" element={<SetPassword />} />
          <Route path="/invite/:code" element={<InvitationLanding />} />
          <Route path="/dashboard/*" element={<Dashboard />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/returns" element={<Returns />} />
          <Route path="/shipping" element={<Shipping />} />
          <Route path="/aviso-legal" element={<AvisoLegal />} />
          <Route path="/withdrawal" element={<Withdrawal />} />
          <Route path="/fragrances/:slug" element={<VariantPage />} />
          <Route path="/layering" element={<LayeringGuide />} />
          <Route path="/ingredients" element={<IngredientsPage />} />
          <Route path="/about" element={<About />} />
          <Route path="/ecosystem" element={<Ecosystem />} />
          <Route path="/blog" element={<BlogIndex />} />
          <Route path="/blog/:slug" element={<BlogPost />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        </main>
      </Suspense>
      </CartProvider>
    </AuthProvider>
  );
}
